const isString = (str): boolean => str != null && typeof str.valueOf() === "string";

const pull = (arr, ...removeList): unknown => {
  const removeSet = new Set(removeList);

  return arr.filter((it) => !removeSet.has(it));
};

let id = 0;

export class Node {
  public id: number;
  public open: string;
  public close: string;
  public text: string;
  public children: Node[];
  public parent: Node;

  constructor(data?) {
    this.id = ++id;
    if (Array.isArray(data)) {
      this.open = data[0];
      this.close = data[1];
    } else if (isString(data)) {
      this.text = data;
    }
    this.children = [];
  }

  public append(e): void {
    if (!(e instanceof Node)) {
      e = new Node(e);
    }
    if (e.parent) {
      e.parent.children = pull(e.parent.children, e);
    }
    e.parent = this;
    this.children = this.children.concat(e);
  }

  public render(): string {
    let text = "";

    if (this.open) {
      text += this.open;
    }
    if (this.text) {
      text += this.text;
    }
    for (let i = 0; i < this.children.length; i++) {
      text += this.children[i].render();
    }
    if (this.close) {
      text += this.close;
    }
    return text;
  }
}
